<template>
  <div id="header_box">
    <div class="header_cont">
      <div class="st_logo" v-if="logo" @click="$router.push('/home')"></div>
      <div class="st_logo2" v-else @click="$router.push('/home')"></div>
      <div class="header_a">
        <router-link active-class="active_a" :to="{path: '/home'}">首页</router-link>
        <!-- <router-link active-class="active_a" :to="{path: '/aso'}" target="_blank">ASO</router-link> -->
        <!-- <a @click="toaso" :class="{active_a: $route.path == '/aso'}">ASO</a> -->
        <a @click="toasa">ASA</a>
        <a @click="toMetahands" :class="{active_a: $route.path == '/metahands'}">MetaHands</a>
        <!-- <router-link active-class="active_a" :to="{path: '/adinterac'}" target="_blank">游戏SaaS </router-link> -->
        <!-- <a @click="tojq">游戏发行</a> -->
        <router-link active-class="active_a" :to="{path: '/about_adjuz'}" target="_blank">关于巨掌</router-link>
        <!-- <a @click="English">English</a> -->
      </div>
    </div>
    <div class="header_bgk_opicaty"></div>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      logo: true
    };
  },
  computed: {},
  components: {},
  created() { },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    toasa() {
      window.open("https://asa.adjz.com/");
    },
    tojq() {
      window.open("http://www.qianjungame.com");
    },
    English() {
      window.open("https://asa.adjz.com/entrance?lg=en");
    },
    toaso() {
      this.$windowopen({ path: "/aso" });
    },
    toMetahands() {
      this.$windowopen({ path: "/metahands" });
    },
    handleScroll() {
      //导航加阴影
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scroolltopnum = scrollTop;
      if (scrollTop > 70) {
        $(".header_bgk_opicaty").css({ "background": "#fff" });
        $(".header_a a").css({ "color": "#11223f" });
        this.logo = false
        $(".header_bgk_opicaty").css({
          "box-shadow": "0 2px 12px 0 rgba(219,229,236,.75)",
        });
      }
      if (scrollTop <= 70) {
        $(".header_bgk_opicaty").css({ "background": "#0f7aff" });
        $(".header_a a").css({ "color": "#fff" });
        this.logo = true
        $(".header_bgk_opicaty").css({
          "box-shadow": "none",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
#header_box {
  position: fixed;
  height: 70px;
  background: #0f7aff;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1024;
  min-width: 1200px;
  .header_bgk_opicaty {
    background: #0f7aff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1800;
    height: 70px;
    z-index: -2;
    overflow: hidden;
    transition: all 0.2s;
  }
  .header_cont {
    width: 1200px;
    display: flex;
    height: 70px;
    //justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
    margin: 0 auto;
    .st_logo {
      height: 70px;
      cursor: pointer;
      float: left;
      width: 130px;
      background: url("./footer_logo.png") no-repeat center center;
      background-size: 130px auto;
      margin-top: -2px;
      margin-right: 60px;
    }
    .st_logo2 {
      height: 70px;
      cursor: pointer;
      margin-right: 60px;
      float: left;
      width: 130px;
      background: url("./home_logo2.png") no-repeat 50%;
      background-size: 130px auto;
      margin-top: -4px;
    }
    .header_a {
      display: flex;
      align-items: center;
      a {
        line-height: 70px;
        color: #fff;
        cursor: pointer;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin: 0 20px;
        letter-spacing: 2px;
        &:hover {
          // color: #409eff;
        }
        &.active_a {
          font-weight: 600;
          // &::after {
          //   content: "";
          //   display: block;
          //   position: absolute;
          //   border-radius: 4px;
          //   width: 60%;
          //   bottom: -8px;
          //   height: 4px;
          //   background: #fff;
          //   left: 50%;
          //   transform: translateX(-50%);
          // }
        }
      }
    }
  }
}
</style>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/header.vue